/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Avatar, Badge } from '@mui/material';
import { styled } from '@mui/material/styles';

const OnlineBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: '0 0 0 2px #374150',
    width: '12%',
    height: '12%',
    borderRadius: '50%',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      content: '""',
    },
  },
}));
const OfflineBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#d5615d',
    color: '#d5615d',
    boxShadow: '0 0 0 2px #374150',
    width: '12%',
    height: '12%',
    borderRadius: '50%',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      content: '""',
    },
  },
}));

export const CustomAvatar = (props) => {
  return (
    <>
      {props.isActive ? (
        <OnlineBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          variant="dot"
        >
          <Avatar
            src={props.src}
            sx={{ width: 80, height: 80, mt: 1 }}
            alt={props.name}
          />
        </OnlineBadge>
      ) : (
        <OfflineBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          variant="dot"
        >
          <Avatar
            src={props.src}
            sx={{ width: 80, height: 80, mt: 1 }}
            alt={props.name}
          />
        </OfflineBadge>
      )}
    </>
  );
};
